import { render, staticRenderFns } from "./ImportantPoints.vue?vue&type=template&id=008c6806&scoped=true&"
import script from "./ImportantPoints.vue?vue&type=script&lang=js&"
export * from "./ImportantPoints.vue?vue&type=script&lang=js&"
import style0 from "./ImportantPoints.vue?vue&type=style&index=0&id=008c6806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008c6806",
  null
  
)

export default component.exports